import type { HttpTransport } from "@common/api/transport";
import type { Crop, CropVariety } from "@common/types";
import type { ID } from "@common/types/api";
import type { CropLabel } from "@common/types/Crop";

export const createCropsApi = (http: HttpTransport) => ({
  destroyCrop: (id: ID) => http.del(`/api/crops/${id}`, {}),

  destroyCropVariety: (id: ID) => http.del(`/api/crop_varieties/${id}`, {}),

  fetchCropLabels: (search: string) =>
    http.get<CropLabel[]>(`/api/crop_labels`, {
      queryParams: { search }
    }),

  fetchCrops: () => http.get<Crop[]>("/api/crops"),

  fetchVarieties: (cropId: number) =>
    http.get<CropVariety[]>(`/api/crop_varieties?crop_id=${cropId}`)
});
